
  <div class="row text-center">
    <div class="col-md-12 col-sm-12 direct-sales-form">
    <app-directsales fromPage="Home" *ngIf="this.showQuickQuote === 'Y'"></app-directsales>
    </div>
  </div>

  